import React from 'react';

export default(key, lang) => {
  let mapping = {
    submitText: {
      en_US: 'Got It',
      de_DE: 'Verstanden',
      el_GR: 'κατανοητή',
      es_ES: 'Entendido',
      fr_FR: 'Compris',
      fr_CA: 'Compris',
      it_IT: 'Inteso',
      pl_PL: 'Zrozumiany',
      th_TH: 'เข้าใจ',
      zh_CN: '明白了',
      pt_BR: 'Entendido',
      ja_JP: '理解した',
    },
    stepSuccessMessage: {
      en_US: 'You have successfully set up Multi-Factor Authentication!',
      de_DE: 'Sie haben die Multi-Faktor-Authentifizierung erfolgreich eingerichtet!',
      el_GR: 'Έχετε ρυθμίσει με επιτυχία την επαλήθευση πολλαπλών παραγόντων!',
      es_ES: '¡Ha configurado correctamente la autenticación multifactor!',
      fr_FR: "Vous avez réussi à configurer l'authentification multifacteur!",
      fr_CA: "Vous avez réussi à configurer l'authentification multifacteur!",
      it_IT: "Hai impostato correttamente l'autenticazione a più fattori!",
      pl_PL: 'Pomyślnie skonfigurowano uwierzytelnianie wieloskładnikowe!',
      th_TH: 'คุณได้ตั้งค่าการรับรองความถูกต้องด้วยหลายปัจจัยสำเร็จแล้ว!',
      zh_CN: '您已经成功设置了多重身份验证！',
      pt_BR: 'Você configurou com êxito a autenticação multifator!',
      ja_JP: '多要素認証が正常に設定されました！',
    },
    stepSuccessMessageForRecovery: {
      en_US: <>You have successfully set up Password Recovery!</>,
      de_DE: <>Sie haben Password Recovery erfolgreich eingerichtet!</>,
      el_GR: <>Έχετε ρυθμίσει με επιτυχία την ανάκτηση κωδικού πρόσβασης!</>,
      es_ES: <>¡Ha configurado correctamente Password Recovery!</>,
      fr_FR: <>Vous avez réussi à configurer la récupération de mot de passe!</>,
      fr_CA: <>Vous avez réussi à configurer la récupération de mot de passe!</>,
      it_IT: <>Hai configurato con successo il recupero della password!</>,
      pl_PL: <>Pomyślnie skonfigurowano odzyskiwanie haseł!</>,
      th_TH: <>คุณได้ตั้งค่าการกู้คืนรหัสผ่านเรียบร้อยแล้ว!</>,
      zh_CN: <>您已成功設定密碼恢復!</>,
      pt_BR: <>Você configurou com sucesso a recuperação de senhas!</>,
      ja_JP: <>パスワードの回復を正常に設定しました。</>,
    },
    stepText: {
      en_US: 'The next time you log in you will be prompted to enter a verification code.',
      de_DE: 'Wenn Sie sich das nächste Mal anmelden, werden Sie aufgefordert, einen Bestätigungscode einzugeben.',
      el_GR: 'Την επόμενη φορά που θα συνδεθείτε, θα σας ζητηθεί να εισαγάγετε έναν κωδικό επαλήθευσης.',
      es_ES: 'La próxima vez que inicie sesión, se le pedirá que ingrese un código de verificación.',
      fr_FR: 'La prochaine fois que vous vous connecterez, vous serez invité à entrer un code de vérification.',
      fr_CA: 'La prochaine fois que vous vous connecterez, vous serez invité à entrer un code de vérification.',
      it_IT: 'Al successivo accesso ti verrà chiesto di inserire un codice di verifica.',
      pl_PL: 'Przy następnym logowaniu pojawi się monit o wprowadzenie kodu weryfikacyjnego.',
      th_TH: 'ครั้งต่อไปที่คุณลงชื่อเข้าใช้คุณจะได้รับแจ้งให้ป้อนรหัสยืนยัน',
      zh_CN: '下次登录时，系统将提示您输入验证码。',
      pt_BR: 'Na próxima vez que você fizer login, você será solicitado a inserir um código de verificação.',
      ja_JP: '次回ログインするときに、確認コードの入力を求められます。',
    },
    stepTextForRecovery: {
      en_US: <>The next time you forget your password, we'll simply text you a code to verify your account. You can always update your phone number from the user menu located in the top right corner of webmail.</>,
      de_DE: <>Wenn Sie Ihr Passwort das nächste Mal vergessen, schreiben wir Ihnen einfach einen Code, um Ihr Konto zu verifizieren. Sie können Ihre Telefonnummer jederzeit über das Benutzermenü in der oberen rechten Ecke von webmail aktualisieren.</>,
      el_GR: <>Την επόμενη φορά που θα ξεχάσετε τον κωδικό πρόσβασής σας, θα σας εισπνεύσουμε απλώς έναν κωδικό για να επαληθεύσουμε το λογαριασμό σας. Μπορείτε πάντα να ενημερώσετε τον αριθμό τηλεφώνου σας από το μενού χρήστη που βρίσκεται στην επάνω δεξιά γωνία του webmail.</>,
      es_ES: <>La próxima vez que olvide su contraseña, simplemente le enviaremos un código para verificar su cuenta. Siempre puede actualizar su número de teléfono desde el menú de usuario ubicado en la esquina superior derecha del correo web.</>,
      fr_FR: <>La prochaine fois que vous oublierez votre mot de passe, nous vous envoyez simplement un code pour vérifier votre compte. Vous pouvez toujours mettre à jour votre numéro de téléphone à partir du menu utilisateur situé dans le coin supérieur droit du webmail.</>,
      fr_CA: <>La prochaine fois que vous oublierez votre mot de passe, nous vous envoyez simplement un code pour vérifier votre compte. Vous pouvez toujours mettre à jour votre numéro de téléphone à partir du menu utilisateur situé dans le coin supérieur droit du webmail.</>,
      it_IT: <>La prossima volta che dimentichi la password, ti invieremo semplicemente un codice per verificare il tuo account. Puoi sempre aggiornare il tuo numero di telefono dal menu utente situato nell'angolo in alto a destra di webmail.</>,
      pl_PL: <>Gdy następnym razem zapomnisz hasła, po prostu wyślemy Ci kod, aby zweryfikować twoje konto. Zawsze możesz zaktualizować swój numer telefonu z menu użytkownika znajdującego się w prawym górnym rogu poczty internetowej.</>,
      th_TH: <>ในครั้งต่อไปที่คุณลืมรหัสผ่าน เราจะส่งข้อความให้คุณเพื่อยืนยันบัญชีของคุณ คุณสามารถอัปเดตหมายเลขโทรศัพท์ของคุณจากเมนูผู้ใช้ที่อยู่ในมุมขวาบนของเว็บเมลได้</>,
      zh_CN: <>下次您忘記密碼時,我們只需給您發送代碼來驗證您的帳戶。您始終可以從 Web 郵件右上角的使用者功能表更新電話號碼。</>,
      pt_BR: <>Da próxima vez que você esquecer sua senha, nós simplesmente enviaremos um código para verificar sua conta. Você sempre pode atualizar seu número de telefone no menu do usuário localizado no canto superior direito do webmail.</>,
      ja_JP: <>次回パスワードを忘れた場合は、アカウントを確認するためのコードを入力します。電話番号は、ウェブメールの右上隅にあるユーザーメニューからいつでも更新できます。</>,
    },
    stepTextApp: {
      en_US: 'This code will be located in the App you just set up.',
      de_DE: 'Dieser Code befindet sich in der App, die Sie gerade eingerichtet haben.',
      el_GR: 'Αυτός ο κώδικας θα βρίσκεται στην εφαρμογή που μόλις δημιουργήσατε.',
      es_ES: 'Este código se ubicará en la aplicación que acaba de configurar.',
      fr_FR: "Ce code sera situé dans l'application que vous venez de configurer.",
      fr_CA: "Ce code sera situé dans l'application que vous venez de configurer.",
      it_IT: "Questo codice si troverà nell'app che hai appena impostato.",
      pl_PL: 'Ten kod będzie znajdować się w właśnie skonfigurowanej aplikacji.',
      th_TH: 'รหัสนี้จะอยู่ในแอพที่คุณเพิ่งตั้งค่า',
      zh_CN: '此代码将位于您刚刚设置的应用程序中。',
      pt_BR: 'Este código estará localizado no aplicativo que você acabou de configurar.',
      ja_JP: 'このコードは、設定したアプリに配置されます。',
    },
    stepTextSms: {
      en_US: 'This code will be sent as a text message to the phone number you just set up.',
      de_DE: 'Dieser Code wird als Textnachricht an die gerade eingerichtete Telefonnummer gesendet.',
      el_GR: 'Αυτός ο κωδικός θα σταλεί ως μήνυμα κειμένου στον αριθμό τηλεφώνου που μόλις δημιουργήσατε.',
      es_ES: 'Este código se enviará como mensaje de texto al número de teléfono que acaba de configurar.',
      fr_FR: 'Ce code sera envoyé par SMS au numéro de téléphone que vous venez de configurer.',
      fr_CA: 'Ce code sera envoyé par SMS au numéro de téléphone que vous venez de configurer.',
      it_IT: 'Questo codice verrà inviato come messaggio di testo al numero di telefono che hai appena impostato.',
      pl_PL: 'Ten kod zostanie wysłany jako wiadomość tekstowa na właśnie skonfigurowany numer telefonu.',
      th_TH: 'รหัสนี้จะถูกส่งเป็นข้อความไปยังหมายเลขโทรศัพท์ที่คุณเพิ่งตั้งค่า',
      zh_CN: '该代码将以短信形式发送到您刚刚设置的电话号码。',
      pt_BR: 'Este código será enviado como uma mensagem de texto para o número de telefone que você acabou de configurar.',
      ja_JP: 'このコードは、設定した電話番号にテキストメッセージとして送信されます。',
    },
  };
  return mapping[key][lang];
};